import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'About',
    component: Home,
    meta: {
      title: 'Dr. Tom Feltwell - About',
      metaTags: [
        {
          name: 'description',
          content: 'About Dr. Tom Feltwell - Human-Computer Interaction Researcher, Research Software Engineer'
        },
        {
          property: 'og:description',
          content: 'About Dr. Tom Feltwell - Human-Computer Interaction Researcher, Research Software Engineer'
        }
      ]
    }
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: () => import(/* webpackChunkName: "portfolio" */ '../views/Portfolio.vue')
  },
  {
    path: '/portfolio/:index',
    name: 'Portfolio Item',
    component: () => import(/* webpackChunkName: "item" */ '../views/Item.vue')
  },
  {
    path: '/contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue'),
    meta: {
      title: 'Dr. Tom Feltwell - Contact',
      metaTags: [
        {
          name: 'description',
          content: 'Contact information for Dr. Tom Feltwell'
        },
        {
          property: 'og:description',
          content: 'Contact information for Dr. Tom Feltwell'
        }
      ]
    }
  },
  // {
  //   path: '/research',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Research.vue'),
  //   meta: {
  //     title: 'Dr. Tom Feltwell - Research Interests',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'Research Interests'
  //       },
  //       {
  //         property: 'og:description',
  //         content: 'Research Interests'
  //       }
  //     ]
  //   }
  // },
  {
    path: '*',
    component: Home,
    meta: {
      title: 'Dr. Tom Feltwell - About'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// From https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
